import axios from "axios";
import * as types from "../mutation-types";
import api from "../../api/api";
import moment from "moment";

export const state = {
  employees: [],
  employee: {},
  pagination: {
    from: 0,
    to: 0,
    totalPage: 0,
    path: "",
    currentPage: 0,
    totalRecord: 0,
    perPage: 0
  },
  createEmployees: null,
  statusCreateEmployees: null,
  getEmployee: {},
  checkEmployee: null,
  statusUpdateEmployee: null,
  getInformationBusinessEmployee: {},
  daysOffExport: []
};

// getters
export const getters = {
  employees: state => state.employees,
  pagination: state => state.pagination,
  employee: state => state.employee,
  createEmployees: state => state.createEmployees,
  statusCreateEmployees: state => state.statusCreateEmployees,
  getEmployee: state => state.getEmployee,
  statusUpdateEmployee: state => state.statusUpdateEmployee,
  getInformationBusinessEmployee: state => state.getInformationBusinessEmployee,
  logAction: state => state.logAction,
  daysOffExport: state => state.daysOffExport
};

// mutations
export const mutations = {
  [types.EMPLOYEE.FETCH_EMPLOYEE](state, data) {
    state.employees = data.employees;
    state.pagination.from = data.employees.from;
    state.pagination.to = data.employees.to;
    state.pagination.totalPage = data.employees.last_page;
    state.pagination.path = data.employees.path;
    state.pagination.currentPage = data.employees.current_page;
    state.pagination.totalRecord = data.employees.total;
    state.pagination.perPage = data.employees.per_page;
    state.logAction = data.resultLogAction;
  },
  [types.EMPLOYEE.SHOW_EMPLOYEE](state, employee) {
    state.employee = employee;
  },
  [types.EMPLOYEE.CREATE_EMPLOYEE](state, res) {
    state.statusCreateEmployees = res;
  },

  [types.EMPLOYEE.GET_EMPLOYEE](state, res) {
    state.getEmployee = res;
  },

  [types.EMPLOYEE.UPDATE_EMPLOYEE](state, res) {
    state.statusUpdateEmployee = res;
  },

  [types.EMPLOYEE.GET_INFO_EMPLOYEE](state, res) {
    state.getInformationBusinessEmployee = res;
  },

  [types.EMPLOYEE.FETCH_EMPLOYEE_DAYS_OFF](state, data) {
    state.employees = data.employees;
    state.pagination.from = data.employees.from;
    state.pagination.to = data.employees.to;
    state.pagination.totalPage = data.employees.last_page;
    state.pagination.path = data.employees.path;
    state.pagination.currentPage = data.employees.current_page;
    state.pagination.totalRecord = data.employees.total;
    state.pagination.perPage = data.employees.per_page;
  },

  [types.EMPLOYEE.FETCH_DAYS_OFF_EXPORT](state, data) {
    state.daysOffExport = data.employees;
  }
};

// actions
export const actions = {
  async fetchEmployee({ commit }, payload) {
    let job_status = null;
    if (payload.jobStatus) {
      job_status = payload.jobStatus;
    }
    const response = await axios.get(api.LIST_EMPLOYEE, {
      params: {
        per_page: payload.optionPage,
        page: payload.currentPage,
        sort_column: payload.columnSort,
        sort_by: payload.sortBy,
        name: payload.name,
        work_type: payload.work_type !== "" ? payload.work_type : null,
        job_title_code: payload.job_title_code,
        company_code: payload.company_code,
        japanese_level: payload.japanese_level,
        foot_code: payload.footCode,
        division_code: payload.divisionCode,
        position_id: payload.positionId,
        job_status: job_status,
        contract_type: payload.contractType,
      }
    });
    commit(types.EMPLOYEE.FETCH_EMPLOYEE, response.data);
  },
  async createEmployee({ commit }, params) {
    const response = await axios.post(api.CREATE_EMPLOYEE, params);
    // TODO show message create success or fail
    commit(types.EMPLOYEE.CREATE_EMPLOYEE, response.status);
  },

  async updateEmployee({ commit }, params) {
    let url = `${api.UPDATE_EMPLOYEE}/${params.id}`;
    const response = await axios.post(url, params.data);
    // TODO show message update success or fail
    commit(types.EMPLOYEE.UPDATE_EMPLOYEE, response.status);
  },

  async getInformationBusinessEmployee(commit) {
    let url = `${api.GET_INFORMATION_EMPLOYEE}/create`;
    const response = await axios
      .get(url)
      .then(res => res)
      .catch(error => {
        return error.response;
      });
    state.checkEmployee = response.status;
    if (response.status == 200) {
      commit(types.EMPLOYEE.GET_INFO_EMPLOYEE, response.data);
    }
  },

  async getEmployee({ commit }, params) {
    let url = `${api.GET_EMPLOYEE}/${params}/edit`;
    const response = await axios
      .get(url)
      .then(res => res)
      .catch(error => {
        return error.response;
      });
    state.checkEmployee = response.status;
    if (response.status == 200) {
      commit(types.EMPLOYEE.GET_EMPLOYEE, response.data);
    }
  },

  async showEmployee({ commit }, payload) {
    const response = await axios.get(api.SHOW_EMPLOYEE + "/" + payload.employeeId, {
      params: {
        start_date: payload.startDate ?? moment().subtract(18, "days").format("YYYY-MM-DD"),
        end_date: payload.endDate ?? moment().format("YYYY-MM-DD"),
      }
    });
    commit(types.EMPLOYEE.SHOW_EMPLOYEE, response.data);
  },

  // eslint-disable-next-line
  async deleteEmployee({ commit }, employeeId) {
    await axios.delete(api.DELETE_EMPLOYEE + "/" + employeeId);
  },

  // eslint-disable-next-line
  resignationEmployee({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post(api.RESIGNATION + "/" + payload.employeeId, {
          resignation_date: payload.resignationDate,
          resignation_reason: payload.resignationReason
        })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // eslint-disable-next-line
  createNoteEmployee({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post(api.CREATE_NOTE_EMPLOYEE + "/" + payload.employeeId, {
          note: payload.note
        })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // eslint-disable-next-line no-unused-vars
  async importNumberOfLeave({ commit }, payload) {
    await axios.post(api.IMPORT_EMPLOYEE_NUMBER_OF_LEAVE, {
      import_file: payload.import_file
    });
  },

  updateNumberOfDaysLeave(payload) {
    // eslint-disable-line no-unused-vars
    return new Promise((resolve, reject) => {
      axios
        .post(api.UPDATE_DAYS_OFF + "/" + payload.employeeId, {
          daysOff: payload.numberOfDaysLeave
        })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  async fetchEmployeeDaysOff({ commit }, payload) {
    const response = await axios.get(api.LIST_EMPLOYEE_DAYS_OFF, {
      params: {
        per_page: payload.optionPage,
        page: payload.currentPage,
        sort_column: payload.columnSort,
        sort_by: payload.sortBy,
        name: payload.name
      }
    });
    commit(types.EMPLOYEE.FETCH_EMPLOYEE_DAYS_OFF, response.data);
  },

  async fetchEmployeeDaysOffExport({ commit }, payload) {
    const response = await axios.get(api.LIST_EMPLOYEE_DAYS_OFF, {
      params: {
        per_page: payload.optionPage,
        page: payload.currentPage,
        sort_column: payload.columnSort,
        sort_by: payload.sortBy,
        name: payload.name,
        export: payload.export
      }
    });
    commit(types.EMPLOYEE.FETCH_DAYS_OFF_EXPORT, response.data);
  },

  async remindEmployeeTimesheet() {
    await axios.post(api.REMIND_EMPLOYEE_TIMESHEET);
  }
};
